<template>
  <app-dropdown
    placeholder="Filter by Client"
    track-by="id"
    label="title"
    :options="clientSelection"
    :loading="loading"
    :disabled="dropdownDisabled"
    v-bind="attrs"
    @on-selected="onClientSelected"
    @on-removed="onClientRemoved"
  />
</template>

<script>
import AppDropdown from "../AppComponents/AppDropdown.vue";
import ApiMixin from "../../mixins/ApiMixin";
import LookupServices from "../../services/lookups";
import Navigation from "../../configs/Perimeters/navigation.js";

/**
 * The value that indicates that selecting this from the
 * dropdown means the user is trying to fetch all
 * clients.
 */
export const ClientListAllOption = {
  id: 0,
  title: "All Clients"
};

export default {
  mixins: [ApiMixin],
  props: ["disableAll"],
  components: {
    AppDropdown
  },
  computed: {
    // The rest of the attributes
    attrs() {
      const { placeholder, options, ...rest } = this.$attrs;
      return rest;
    },
    // Function to determine if the dropdown should be disabled
    dropdownDisabled() {
      if (this.loading) return true;
      if (this.attrs.disabled) return this.attrs.disabled;

      return false;
    },
    // Holds the data for the client selection to be displayed
    clientSelection() {
      let baseSelection = [];
      if (this.response) baseSelection = this.response.data.lookups;

      // Sort the client list alphabetically.
      baseSelection.sort((a, b) => a.title.localeCompare(b.title));

      const isAdmin = Navigation.isSuperAdmin() || Navigation.isAdmin();
      const allOptionIsNotDisabled = (undefined === this.disableAll || false === this.disableAll);

      if (isAdmin && allOptionIsNotDisabled) {
        baseSelection.unshift(ClientListAllOption);
      }
      
      this.$emit("on-client-selection-updated", baseSelection);

      return baseSelection;
    }
  },
  methods: {
    async fetchClients() {
      await this.request(LookupServices.getClients);
    },
    onClientSelected(props) {
      this.$emit("on-client-selected", props);
    },
    onClientRemoved(props) {
      this.$emit("on-client-removed", props);
    }
  },
  mounted() {
    this.fetchClients();
  },
  inheritAttrs: false
};
</script>
